import { AuthenticationService } from '../../authentication.service';
var AuthorizeInterceptor = /** @class */ (function () {
    function AuthorizeInterceptor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    AuthorizeInterceptor.prototype.intercept = function (currentHttpRequest, next) {
        // No authorisation needed
        if (!currentHttpRequest.url.includes('breeze')) {
            return next.handle(currentHttpRequest);
        }
        // Clone the request and add the cache headers
        var newHttpRequest = currentHttpRequest.clone({
            setHeaders: {
                'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()
            }
        });
        // And handle the error responses if needed
        return next.handle(newHttpRequest);
    };
    return AuthorizeInterceptor;
}());
export { AuthorizeInterceptor };
